import { render, staticRenderFns } from "./KUsersList.vue?vue&type=template&id=233a9667&"
import script from "./KUsersList.vue?vue&type=script&lang=js&"
export * from "./KUsersList.vue?vue&type=script&lang=js&"
import style0 from "./KUsersList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports